<template>
  <div class="select-box">
    <div class="select-item-box item1">
      <div @click="chooseAllcode()" :class="{active:choosefirst===true}">全部</div>
      <div :class="{active:selected1Code.indexOf(t1.orgCode)!==-1}" v-for="t1 in items"
           :key="t1.orgCode"
           @click="item1Click(t1)"
      >{{t1.orgSname}}</div>
    </div>
    <div v-if="filterType==='branch'" class="select-item-box" :style="{width:filterType==='product'?'66%':'33%'}">
      <div class="chooseAll" @click="chooseAllSecond()" :class="{chooseClass:choosesecondAll===true}">全选</div>
      <div v-show="item2Show" class="item3" :class="{active:selected2Code.indexOf(t2.orgCode)!==-1}" v-for="t2 in items2"
           :key="t2.orgCode"
           @click="item2Click(t2)"
      >
        <span>{{t2.orgSname}}</span>
        <span :style="{visibility:selected2Code.indexOf(t2.orgCode)!==-1?'unset':'hidden'}">
          <van-icon name="success"  color="#3399FF"/>
        </span>
      </div>
    </div>
    <div v-if="filterType==='product'" class="select-item-box" :style="{width:filterType==='product'?'66%':'33%'}">
      <div class="item3" v-show="item2Show" :class="{active:selected2Code.indexOf(t2.orgCode)!==-1}" v-for="t2 in items2"
           :key="t2.orgCode"
           @click="item2Click(t2)"
      >
        <span>{{t2.orgSname}}</span>
        <span :style="{visibility:selected2Code.indexOf(t2.orgCode)!==-1?'unset':'hidden'}">
          <van-icon name="success"  color="#3399FF"/>
        </span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'MyTreeSelect',
  data () {
    return {
      items2: [],
      items3: [],
      item2Show: false,
      item3Show: false,
      selected1: {},
      selected2: {},
      selected3: {},
      selected1Code: [],
      selected2Code: [],
      selected3Code: [],
      choose1: {},
      choosesecondAll: false,
      choosefirst: false
    }
  },
  props: {
    items: {
      type: Array,
      require: true
    },
    filterType: {
      type: String,
      require: true
    }
  },
  methods: {
    item1Click (t1) {
      this.choose1 = t1
      if (this.selected1[t1.orgCode]) {
        delete this.selected1[t1.orgCode]
        this.selected1Code.splice(this.selected1Code.indexOf(t1.orgCode), 1)
        this.item2Show = false
        this.item3Show = false
        if (this.selected1Code.length > 0) {
          this.items2 = this.selected1[this.selected1Code[0]].children
          this.item2Show = true
        }
        let codes = []
        for (let key in this.selected2) {
          let item = this.selected2[key]
          if (item.parentNode === t1.orgCode) {
            delete this.selected2[key]
            this.selected2Code.splice(this.selected2Code.indexOf(item.orgCode), 1)
            codes.push(item.orgCode)
          }
        }
        if (this.selected2Code.length > 0) {
          this.items3 = this.selected2[this.selected2Code[0]].children
          this.item3Show = true
        }
        for (let key in this.selected3) {
          let x = this.selected3[key]
          if (codes.indexOf(x.parentNode) !== -1) {
            delete this.selected3[key]
            this.selected3Code.splice(this.selected3Code.indexOf(x.orgCode), 1)
          }
        }

        return
      }
      this.$emit('chooseData1', this.selected1)
      if (t1.children) {
        this.items2 = t1.children
        this.item2Show = true
        this.item3Show = false
        this.selected1[t1.orgCode] = t1
        this.selected1Code.push(t1.orgCode)
      }
    },
    item2Click (t2) {
      if (this.selected2[t2.orgCode]) {
        delete this.selected2[t2.orgCode]
        this.selected2Code.splice(this.selected2Code.indexOf(t2.orgCode), 1)
        return
      }
      if (this.filterType === 'product') {
        this.selected2[t2.orgCode] = t2
        this.selected2Code.push(t2.orgCode)
        return
      }
      this.selected2[t2.orgCode] = t2
      this.selected2Code.push(t2.orgCode)
      this.$emit('chooseData2', this.selected2)
    },
    chooseAllcode () {
      this.choosefirst = !this.choosefirst
    },
    chooseAllSecond () {
      this.choosesecondAll = !this.choosesecondAll
      if (this.choosesecondAll) {
        for (let i = 0; i < this.choose1.children.length; i++) {
          if (this.selected2[this.choose1.children[i].orgCode]) {
            return
          } else {
            this.selected2[this.choose1.children[i].orgCode] = this.choose1.children[i]
            this.selected2Code.push(this.choose1.children[i].orgCode)
            this.$emit('chooseData2', this.selected2)
          }
        }
      } else {
        for (let i = 0; i < this.choose1.children.length; i++) {
          if (this.selected2[this.choose1.children[i].orgCode]) {
            delete this.selected2[this.choose1.children[i].orgCode]
            this.selected2Code.splice(this.selected2Code.indexOf(this.choose1.children[i].orgCode), 1)
          } else {
          }
        }
      }
    }
  },
  created () {
    this.$emit('itemsClik', this.$props.items)
  }
}
</script>

<style lang="stylus" scoped>
.select-box{
  display: flex;
  justify-content: start;
  align-content: stretch;
  box-sizing: border-box;
}
.select-item-box{
  width:50% !important;
  box-sizing: border-box;
  /*border:1px solid #ddd;*/
}
.select-item-box>div{
  padding: .1rem 0;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  color:#999;
  font-weight normal
}
.select-item-box>div.active{
  font-weight: 600;
  color: #333;
}
.item1>div{
  background-color: #F3F5F9;
}
.item1>div.active{
  position: relative;
  background-color: #fff;

}
.item1>div.active::before{
  display: inline-block;
  content: '';
  border-left: .02rem solid #3399FF;
  left: 0;
  top: 15%;
  height:70%;
  position: absolute;
}
.item3{
  display:flex;
  justify-content: space-around;
  align-items:center;
}
.item3>span:last-child{
  flex-grow:1;
}
.item3>span:first-child{
  text-overflow: ellipsis;
  overflow:hidden;
  flex-grow:3;
}
.chooseClass{
  color:#000!important
}
// .select-item-box .chooseAll{
//   text-align left
//   padding-left .1rem
// }
</style>



// WEBPACK FOOTER //
// src/pages/entirety/components/screens/MyTreeSelect.vue